import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {AcDialog, DIALOG_CONFIG} from 'ac-infra';
import _ from 'lodash';
import {MatRadioChange} from '@angular/material/radio';

@AcDialog({
  width: 500,
  height: 430
})
@Component({
  selector: 'calls-quota-dialog',
  templateUrl: './calls-quota-dialog.component.html',
  styleUrls: ['./calls-quota-dialog.component.scss']
})
export class CallsQuotaDialogComponent implements OnInit, AfterViewInit {

  @ViewChild('callsQuotaDialog') callsQuotaDialog: NgForm;
  callsQuota;
  dateOptions = [];

  daysOptions = [
    { text: 'Mon', value: 'MON'},
    { text: 'Tue', value: 'TUE'},
    { text: 'Wed', value: 'WED'},
    { text: 'Thu', value: 'THU'},
    { text: 'Fri', value: 'FRI'},
    { text: 'Sat', value: 'SAT'},
    { text: 'Sun', value: 'SUN'}
  ];

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig) {
    this.callsQuota = dialogConfig.dialogData;
    this.dialogConfig.submitButtonDisabled = true;
  }

  ngOnInit(): void {
    for (let i = 1; i <= 31; i++) {
      this.dateOptions.push({ text: String(i).padStart(2, '0'), value: i});
    }
  }

  ngAfterViewInit(): void {
    this.callsQuotaDialog.form.statusChanges.subscribe(() => {
      this.setSubmitButtonDisabled();
    });
  }

  showCountFromDayNotice(): boolean {
    return (this.callsQuota.periodicity === 'MONTHLY') &&
      _.isNumber(this.callsQuota.firstDayOfMonth) &&
      this.callsQuota.firstDayOfMonth > 28;
  }

  periodicityChange(change: MatRadioChange): void {
    this.setSubmitButtonDisabled();
  }

  setSubmitButtonDisabled(): void{
    this.dialogConfig.submitButtonDisabled = !this.callsQuotaDialog.form.valid
      || (this.callsQuota.periodicity === 'MONTHLY' && !this.callsQuota.firstDayOfMonth)
      || (this.callsQuota.periodicity === 'WEEKLY' && !this.callsQuota.firstDayOfWeek);
  }

}
